<template xmlns="http://www.w3.org/1999/html">
    <tr>
        <td class="first-column">
            <input type="text" v-model="name"><button @click="createProjectMaterial()">Add material</button>
        </td>
        <td :colspan="calendar.length"></td>
    </tr>
</template>
<style scoped>
    .table-condensed td {
        padding: 0;
    }
    .currency::after{
        content: "€";
    }
    .curweek {
        font-weight: bold;
    }
    .first-column {
        position: sticky;
        position: -webkit-sticky;
        left: 0;
        z-index: 1;
        background: white;
    }
</style>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'NewProjectMaterialRow',
  components: {
  },
  props: {
    projectId: ''
  },
  data: function () {
    return {
      name: '',

    };
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects', 'projectCategories']),
    ...mapGetters('Worklogs', ['datesByYearweek', 'yearweeksByDate', 'curweek', 'calendar']),
    ...mapGetters('ProjectMaterials', []),
  },
  methods: {
    ...mapActions('ProjectMaterials', ['CREATE_PROJECT_MATERIAL']),
    createProjectMaterial() {
      this.CREATE_PROJECT_MATERIAL({ projectId: this.projectId, name: this.name });
    }
  },
  mounted() {
  },
};

</script>

<style scoped>
    input {
        line-height: normal;
    }
    button {
        line-height: normal;
    }
    td {
        white-space: nowrap;
        width: 1px;
        padding-right: 40px !important;
    }
</style>
